
export function HtmlDiv({
  children,
  className,
  style,
}: {
  className?: string | null | undefined;
  style?: any;
  children: string | null | undefined;
}) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: children || "",
      }}
      style={style}
      className={className || ""}
    ></div>
  );
}